import './index.less'

export default {
  props:['city','showCar','areacode'],
  methods:{
    handleClick(data){
      this.$emit('change',data.code)
    }
  },
  render() {
    const {areacode, city} = this
    return <div class="city-shortcut">
      <div class="city-shortcut__header" style="">
        <Icon style="margin-right:6px" custom={this.showCar ? 'i-icon icon-car' : 'i-icon icon-company'}></Icon>
        {this.showCar ? '车辆地图' : '网点地图'}
      </div>
      <div class="city-shortcut__body city-shortcut__body--double">
        {
          city.map(i => <div on-click={() => this.handleClick(i)} style="" class={['city-shortcut-item',areacode == i.code ? 'city-shortcut-item--selected':null]}>
            {i.name}
          </div>)
        }
      </div>
      <div on-click={() => this.handleClick({code:'86'})} class="city-shortcut__footer">返回全国</div>
    </div>
  }
}